import { createFileRoute } from '@tanstack/react-router'
import { AdminCustomersDirectory } from '@/components/admin/AdminCustomersDirectory'

export const Route = createFileRoute('/admin/customers')({
  component: () => <AdminCustomersDirectory />,
})
